import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import DataSyncTaskModal from './DataSyncTaskModal';
import { DATA_SYNC_MODAL_ROUTE } from '../../constants/routeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const DataSyncModalWrapper = () => {
  const {
    location: {
      pathname
    },
    push
  } = useHistory();
  const [showModal, setShowModal] = useState(true);
  const handleClose = () => {
    setShowModal(false);
    if (pathname.includes(DATA_SYNC_MODAL_ROUTE)) {
      push('/');
    }
  };
  if (!showModal) {
    return null;
  }
  return /*#__PURE__*/_jsx(DataSyncTaskModal, {
    onClose: handleClose,
    onOpenModal: () => {}
  });
};
export default DataSyncModalWrapper;